/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useLazyQuery } from '@apollo/client';

export const useUpdatePriceOnPaymentMethod = () => {

    const UPDATE_PRICE_PAYMENT_GQL = gql`
       query UpdatePriceOnPaymentMethod($markup: Boolean!, $orderId: String!) {
  updatePriceOnPaymentMethod(markup: $markup, orderId: $orderId) {
    priceUpdate
  }
}
    `;

    const [updatePriceOnPaymentMethod, updatePriceOnPaymentMethodData] = useLazyQuery(UPDATE_PRICE_PAYMENT_GQL,{context:{clientName:"cart"}})

    return {updatePriceOnPaymentMethod, updatePriceOnPaymentMethodData};
}